import { useQuery } from "@tanstack/react-query";
import type { OrgChartPerson } from "@/lib/org-chart";
import { organizationKeys } from "@/lib/query";

/** Flat list of active people (with presigned avatar URLs) for the org chart. */
export function useOrgChart() {
  return useQuery({
    queryKey: organizationKeys.chart(),
    queryFn: async (): Promise<OrgChartPerson[]> => {
      const res = await fetch("/api/organization/chart");
      if (!res.ok) throw new Error("Failed to load the org chart");
      const json = await res.json();
      return json.data;
    },
  });
}
